export enum CrudOperationEnum {
  GET = 1,
  POST = 2,
  PUT = 3,
  DELETE = 4,
}
